import { render } from "./App.vue?vue&type=template&id=ba90853e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ba90853e&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__